import React from 'react';
import { COMBINE_PROJECT } from 'actions';

type Props = {
  dispatch: Function,
  selectedProjects: {[projectId: string]: boolean},
};

export default class YourProjectsCombineSelected extends React.Component<Props> {
  getProjectsIds = () => {
    const { selectedProjects } = this.props;
    if (!selectedProjects || typeof selectedProjects !== 'object') {
      return [];
    }
    return Object.keys(selectedProjects).filter(projectId => selectedProjects[projectId] === true);
  }

  combineProject = () => {
    const { dispatch } = this.props;
    const projects = this.getProjectsIds();

    if (projects.length > 1) {
      dispatch(COMBINE_PROJECT(projects));
    }
  }

  render() {
    const projectsIds = this.getProjectsIds();
    const canCombine = projectsIds.length > 1;

    return (
      <div className="your-projects-combine-selected">
        <a
          onClick={canCombine ? this.combineProject : undefined}
          className={canCombine ? '' : 'not-available'}
        >
          <i className="material-icons">merge_type</i>
          <div className="text">COMBINE SELECTED</div>
        </a>
      </div>
    );
  }
}
